module.exports = __webpack_public_path__ + "51ef399006f1f4f52306cb155b1239bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/lvy_c.png
// module id = 252
// module chunks = 3